var render = function render(){var _vm=this,_c=_vm._self._c;return _c('step-container',{attrs:{"data":_vm.data,"on-submit":_vm.submit,"required-data":() => []}},[_c('v-card',{attrs:{"flat":""}},[_c('custom-wording-data',{staticClass:"mx-4",attrs:{"data":_vm.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }